const starterObjects = {
    "4DE9382D-6324-4CDA-90AE-05BF2AD82670": {
        "height": 1,
        "width": 1,
        "x": 0,
        "y": 0,
    },
    "8FF4C4FB-B6BD-419C-8EF1-5AC00AC8D859": {
        "x": 0.04,
        "y": 0.02,
        "width": 0.92,
        "height": 0.07,
        "fontSize": "75rem",
    },
    "5B9669CF-727F-467E-8234-61F0A823C45A": {
        "x": 0.04,
        "y": 0.1,
        "width": 0.92,
        "height": 0.05,
        "fontSize": "48rem",
    },
    "910F8801-9758-47FF-8144-C0BFF5A60D3A": {
        "x": 0.04,
        "y": 0.35,
        "width": 0.28,
        "height": 0.0375,
        "fontSize": "36rem",
    },
    "F6CC4955-839B-4CF3-A564-39D5E7FB48D2": {
        "x": 0.04,
        "y": 0.41,
        "width": 0.92,
        "height": 0.09,
        "fontSize": "36rem",
    },
    "85FE0BA5-11F1-45D7-BFE8-5D4DB2019E43": {
        "x": 0.04,
        "y": 0.51,
        "width": 0.92,
        "height": 0.47,
        "fontSize": "75rem",
    }
}
function calcObjWidth(obj, {width, fontSize} = {}) {
    let tempCnt = document.createElement("div");
    let w = width || 1920;
    let h = w * 0.5625
    tempCnt.style.width = `${w}px`;
    tempCnt.style.height = `${h}px`;
    tempCnt.style.position = "absolute";
    tempCnt.style.zIndex = "-1";
    tempCnt.style.pointerEvents = "none";
    document.body.appendChild(tempCnt);
    if (!document.documentElement.style.fontSize) {
        document.documentElement.style.fontSize = "24px"
    }
    let tempEl = document.createElement('div');
    let contentEl = document.createElement('div');
    contentEl.style.display = "inline-block";
    contentEl.innerHTML = obj.content;
    if (fontSize) {
        contentEl.style.fontSize = fontSize;
        contentEl.querySelectorAll("*").forEach((el) => {if (el.style) {el.style.fontSize = fontSize}})
    }
    tempEl.appendChild(contentEl);
    tempCnt.appendChild(tempEl);
    let objWidth = Math.min(0.8, Math.ceil(tempEl.children[0].offsetWidth / w * 100) / 100 + 0.03);
    // tempCnt.parentElement.removeChild(tempCnt);
    return objWidth;
}
function objVisibleMobile(uuid) {
    return Q3.SlideManager.currentSlide.layers[uuid]
      && Q3.data.layers.layers2D[uuid]
      && Q3.data.layers.layers2D[uuid].objects
      && Object.values(Q3.data.layers.layers2D[uuid].objects)[0]
      && !Object.values(Q3.data.layers.layers2D[uuid].objects)[0].hiddenMobile
}
function set2DMobilePosAndSize(opts = {}) {
    let lgAspect = {x: 16, y: 9};
    const layers2D = Q3.data.layers.layers2D;
    let textboxes = [];
    let mathFormulas = [];
    let pictures = [];
    let imgCarouseles = [];
    let quizPictures = [];
    let videos = [];
    let lines = [];
    let slideQuiz = Q3.SlideManager.currentSlide.slideQuiz;
    let has2DQuiz = slideQuiz && slideQuiz.active && (['region', 'dragDrop2d'].indexOf(slideQuiz.type) !== -1 || slideQuiz.layoutMobile === "compact");
    Object.keys(Q3.SlideManager.currentSlide.layers2D).filter(objVisibleMobile).forEach(lUuid => {
        if (layers2D[lUuid] && layers2D[lUuid].objects && Object.values(layers2D[lUuid].objects)[0]) {
            let obj = Object.values(layers2D[lUuid].objects)[0];
            obj.sizeSm = obj.sizeSm || {};
            if (!obj.sizeSm.autoResized || opts.force) {
                let entity = {lUuid: lUuid, obj: obj}
                if (obj.type === "text") {
                    textboxes.push(entity)
                }
                if (obj.type === "line") {
                    lines.push(entity)
                }
                if (obj.type === "mathFormula") {
                    mathFormulas.push(entity)
                }
                if (obj.type === "picture") {
                    if (has2DQuiz) {
                        quizPictures.push(entity)
                    } else {
                        pictures.push(entity)
                    }
                }
                if (obj.type === "video") {
                    videos.push(entity)
                }
                if (obj.type === "imageCarousel") {
                    imgCarouseles.push(entity)
                }
            }

        }
    })
    const getObjCenterVal = (obj) => {
        return (obj.sizeLg.width / 2) * lgAspect.x + obj.sizeLg.x * lgAspect.x + (obj.sizeLg.height / 2) * lgAspect.y + obj.sizeLg.y * lgAspect.y;
    }
    const sortFn = (t1, t2) => (getObjCenterVal(t1.obj) > getObjCenterVal(t2.obj)) ? 1 : -1;
    textboxes = textboxes.sort(sortFn)
    videos = videos.sort(sortFn)
    pictures = pictures.sort(sortFn)

    let top = slideQuiz && slideQuiz.active ? (slideQuiz.layoutMobile === "compact" ? 0.33 : 0.2) : 0.025;
    let left = 0.025;
    let container = Q3.letterbox;
    let tempCnt;
    let oneRem = parseFloat(document.querySelector("html").style.fontSize)
    if (Q3.editMode) {
        tempCnt = document.createElement("div");
        tempCnt.style.width = "360px";
        tempCnt.style.height = "640px";
        tempCnt.style.position = "absolute";
        tempCnt.style.zIndex = "-1";
        tempCnt.style.pointerEvents = "none";
        document.body.appendChild(tempCnt);
        oneRem = 11.25;
        container = tempCnt;
    }
    lines.forEach(el => {
        let l = el.obj;
        let initialData = {
            x1: l.x1,
            x2: l.x2,
            y1: l.y1,
            y2: l.y2,
        };
        if (!l.sizeLg || !Object.keys(l.sizeLg).length) {
            l.sizeLg = JSON.parse(JSON.stringify(initialData));
        }

        if (!l.sizeSm || !Object.keys(l.sizeSm).length) {
            l.sizeSm = JSON.parse(JSON.stringify(l.sizeLg));
        }
    });
    [...textboxes, ...mathFormulas].forEach(el => {
        let t = el.obj;
        if (starterObjects[el.lUuid]) {
            t.sizeSm = JSON.parse(JSON.stringify(starterObjects[el.lUuid]));
            if (el.lUuid === "910F8801-9758-47FF-8144-C0BFF5A60D3A") {
                t.sizeSm.width = calcObjWidth(t, {width: Q3.container.offsetWidth, fontSize: parseFloat(t.sizeSm.fontSize)/24 + "rem"})
            }
        } else {
            let styles = {
                position: "absolute",
                width: (1 - left * 2) * container.offsetWidth + "px",
                top: top * container.offsetHeight + "px",
                left: left * container.offsetWidth + "px",
            };
            let tempEl = document.createElement('div');
            let contentEl = document.createElement('div');
            contentEl.style.display = "inline-block";
            contentEl.innerHTML = t.content;
            if (t.type === "mathFormula" && typeof MathJax !== "undefined") {
                MathJax.typesetPromise([contentEl])
            }
            Object.assign(contentEl.style, {
                lineHeight: t.lineHeight || 1.4,
                fontSize: parseFloat(t.sizeSm.fontSize) / 24 * oneRem + "px"
            })
            contentEl.querySelectorAll("*").forEach((el) => {if (el.style) {el.style.fontSize = parseFloat(t.sizeSm.fontSize) / 24 * oneRem + "px"}})
            if (t.extraStyles) {
                ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"].forEach(p => {
                    if (t.extraStyles[p]) {
                        contentEl.style[p] = parseFloat(t.extraStyles[p]) / 24 * oneRem + 2 + "px"
                    }
                })
            }
            Object.assign(tempEl.style, styles);
            tempEl.appendChild(contentEl);
            container.appendChild(tempEl);
            t.sizeSm.width = Math.min(1 - left * 2, Math.ceil(tempEl.children[0].offsetWidth / container.offsetWidth * 100) / 100);
            t.sizeSm.height = tempEl.scrollHeight / container.offsetHeight;
            t.sizeSm.x = (1-t.sizeSm.width)/2;
            if (top + t.sizeSm.height > 1) {
                top = 1 - t.sizeSm.height;
                left = Math.min(1 - t.sizeSm.width, left + 0.05)
            }
            t.sizeSm.y = top;
            top += (t.sizeSm.height + 0.02);
        }

    });

    [...videos, ...pictures, ...imgCarouseles].forEach(el => {
        let obj = el.obj;
        if (obj.sizeLg && (!obj.sizeSm || !Object.keys(obj.sizeSm).length)) {
            obj.sizeSm = JSON.parse(JSON.stringify(obj.sizeLg));
        }
        if (starterObjects[el.lUuid]) {
            obj.sizeSm = starterObjects[el.lUuid];
        } else {
            let c = ((1 - left * 2) / obj.sizeSm.width);
            obj.sizeSm.width = (1 - left * 2)
            obj.sizeSm.height = obj.sizeSm.height * c

            obj.sizeSm.x = left;
            if (top + obj.sizeSm.height > 1) {
                top = 1 - obj.sizeSm.height;
                left = Math.min(1-obj.sizeSm.width, left + 0.05)
            }
            obj.sizeSm.y = top;

            top += (obj.sizeSm.height + 0.0025);
        }
    })
    let itemsInRow = 3;
    let squareSize = 90/itemsInRow/100;
    let gutterSize = 10/(itemsInRow + 1)/100;
    left = gutterSize;
    quizPictures.forEach((el, i) => {
        let obj = el.obj
            obj.sizeSm.width = squareSize;
            obj.sizeSm.height = squareSize*(9/16);
            let row = Math.floor(i/itemsInRow);
            let isLastRow = quizPictures.length - (itemsInRow*row) <= itemsInRow;
            let lastRowOffset = 0;
            if (isLastRow) {
                lastRowOffset = (itemsInRow - (quizPictures.length - (itemsInRow*row)))*(squareSize+gutterSize)/2
            }
            let col = i%itemsInRow;
            obj.sizeSm.x = lastRowOffset + gutterSize + gutterSize*col + squareSize*col;
            obj.sizeSm.y = top + (gutterSize + squareSize*(9/16))*row;
    })
    top = top + (gutterSize + squareSize*(9/16))*Math.ceil(quizPictures.length/itemsInRow) - gutterSize
    if (Q3.editMode) {
        [...textboxes, ...videos, ...pictures, ...mathFormulas, ...imgCarouseles].forEach(el => {
            el.obj.sizeSm.autoResized = true;
        })
    }
    if (opts.force) {
        Q3.layers.stack.filter(l => l.objects[0]).map(l => l.objects[0]).forEach(obj => {
            if (obj.data.sizeSm && Object.keys(obj.data.sizeSm).length) {
                obj.sizeSm = obj.data.sizeSm;
                if (obj.addMobileFontSize) {
                    obj.addMobileFontSize();
                }
            }
        })
    }
    if (tempCnt) {
        tempCnt.remove();
    }
}
export default set2DMobilePosAndSize;
export { calcObjWidth, set2DMobilePosAndSize }
